import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import { loadModuleSeriesAdmin } from '../../../../../state/modules/learningsAdmin/actions';
import ModuleSerieInput from '../components/ModuleSerieInput';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 20;
const defaultOrder = 'order.asc';
const defaultAction = 'all';
const defaultScope = 'list';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learningsAdmin.getIn(
        [
          'moduleSeriesAdmin',
          defaultScope,
          partnershipId,
          defaultAction,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModuleSeriesAdmin', x]),
              schema.learningModuleSerieAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];
  return {
    options: list,
    isLoading: state.learningsAdmin.get('isLoading'),
    partnershipId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      action = defaultAction,
      filter = {},
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      scope = defaultScope,
      cb = function () {}
    ) => {
      dispatch(
        loadModuleSeriesAdmin(
          partnershipId,
          action,
          filter,
          page,
          limit,
          order,
          scope,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleSeriesAdmin(
                    partnershipId,
                    action,
                    filter,
                    i,
                    limit,
                    order,
                    scope
                  )
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const ModuleSerieInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModuleSerieInput);

export default ModuleSerieInputContainer;
